<template>
  <section id="contact" class="contact">
    <h2 class="contact_title">Contact</h2>
    <div class="contact_section">
        <div class="contact_left">
            <p class="contact_left_text">Want to work together?</p>
            <p class="contact_left_text_2">Let’s build something amazing. Feel free to reach out. I’d love to hear from you.</p>

            <a href="tel: +447919266634"><div class="conatct_div">
                <img class="contact_icon" src="../assets/call_icon_2.png" alt="Phone" />
                <p class="contact_text">+447919266634</p>
            </div></a>

            <a href="mailto: ifechukwucnwachukwu@gmail.com" target="_blank"><div class="conatct_div">
                <img class="contact_icon" src="../assets/email_icon_2.png" alt="Email" />
                <p class="contact_text">ifechukwucnwachukwu@gmail.com </p>
            </div></a>

            <a href="https://www.linkedin.com/in/ifechukwu-nwachukwu/" target="_blank"><div class="conatct_div">
                <img class="contact_icon" src="../assets/linkedin_icon_2.png" alt="LinkedIn" />
                <p class="contact_text">Ifechukwu Nwachukwu</p>
            </div></a>

            <a href="https://github.com/ICN-1" target="_blank"><div class="conatct_div">
                <img class="contact_icon" src="../assets/github_icon_2.png" alt="GitHub" />
                <p class="contact_text">ICN-1</p>
            </div></a>

            <a href="https://www.instagram.com/ify_icn/" target="_blank"><div class="conatct_div">
                <img class="contact_icon" src="../assets/instagram_icon.png" alt="Instagram" />
                <p class="contact_text">ify_icn</p>
            </div></a>

            <a href="https://www.instagram.com/themovinityplace/" target="_blank"><div class="conatct_div">
                <img class="contact_icon" src="../assets/instagram_icon_2.png" alt="Instagram" />
                <p class="contact_text a" style="color: #4B9CD3;">themovinityplace</p>
            </div></a>
        </div>

        <form class="contact_right" method="post" @submit.prevent="submitForm">
            <p class="contact_right_text">Name</p>
            <input class="contact_right_input" type="text" name="name" placeholder="Your Name" v-model="form.name" required />

            <p class="contact_right_text">Email</p>
            <input class="contact_right_input" type="email" name="email" placeholder="abc@example.com" v-model="form.email" required />

            <p class="contact_right_text">Message</p>
            <textarea class="contact_right_textarea" name="message" placeholder="How can I help?" v-model="form.message" required ></textarea>
            
            <div class="send_message_button" @click="submitForm">
                <p class="send_message_text">{{ submitting ? 'Sending...' : 'Send Message' }}</p>
            </div>

            <p v-if="success" style="color: green; font-weight: 600; align-self: center; margin-top: 5px;">Message sent successfully!</p>
            <p v-if="error" style="color: red; font-weight: 600; align-self: center; margin-top: 5px;">Failed to send message. Try again later.</p>
        </form>
    </div>
    <!-- <a href="/contact" class="cta-btn">Contact Me</a> -->
  </section>
</template>

<script>
    export default {
        data() {
            return {
                form: {
                    name: '',
                    email: '',
                    message: ''
                },
                submitting: false,
                success: false,
                error: false
            };
        },
        methods: {
            async submitForm() {
                this.submitting = true;
                this.success = false;
                this.error = false;

                const formData = new FormData();
                formData.append('name', this.form.name);
                formData.append('email', this.form.email);
                formData.append('message', this.form.message);

                try {
                    const response = await fetch('https://formspree.io/f/xldglgkj', {
                        method: 'POST',
                        body: formData,
                        headers: {
                            Accept: 'application/json'
                        }
                    });

                    if (response.ok) {
                        this.success = true;
                        this.form.name = '';
                        this.form.email = '';
                        this.form.message = '';
                    } else {
                        this.error = true;
                    }
                } catch (e) {
                    this.error = true;
                }

                this.submitting = false;
            }
        }
    };
</script>

<style scoped>
    .contact {
        height: 100vh;
        width: 80%;
        /* padding-top: 100px; */
        /* padding-bottom: 100px; */
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        /* border-bottom: 3px solid rgb(73, 2, 46, 0.5); */
    }

    .contact_title{
        font-size: 42px;
        font-weight: 700;
        color: rgb(150, 8, 96);
        /* text-align: left; */
        width: 100%;
    }

    .contact_section{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        margin-top: 50px;
        gap: 50px;
    }

    .contact_left{
        width: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: start;
    }

    .contact_left_text{
        font-size: 32px;
        font-weight: 600;
        color: #A5A5A5;
        /* margin-top: 20px; */
        text-align: left;
        /* width: 80%; */
    }

    .contact_left_text_2{
        font-size: 20px;
        color: #A5A5A5;
        margin-top: 10px;
        text-align: left;
    }

    .contact_right{
        width: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;
        padding: 30px;
        align-items: start;
        border: 2px solid black;
        border-radius: 20px;
        background-color: rgb(73, 2, 46, 0.5);
    }

    .contact_right_text{
        color: rgb(244, 187, 222);
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 10px;
    }

    .contact_right_input{
        width: 100%;
        padding: 10px;
        border: none;
        border-radius: 5px;
        margin-bottom: 30px;
        background-color: rgba(85, 3, 53, 0.8);
        color: rgb(244, 187, 222);
        font-size: 18px;
    }

    .contact_right_textarea{
        width: 100%;
        height: 100px;
        padding: 10px;
        margin-bottom: 50px;
        border: none;
        border-radius: 5px;
        background-color: rgba(85, 3, 53, 0.8);
        color: rgb(244, 187, 222);
        font-size: 18px;
        resize: none;
    }

    .send_message_button{
        position: relative;
        width: 100%;
        padding: 20px;
        background-color: rgba(85, 3, 53, 0.8);
        border: 2px solid black;
        border-radius: 5px;
        cursor: pointer;
    }

    .send_message_button::before {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        transform: scaleY(0);
        transform-origin: bottom;
        transition: transform 0.4s ease;
        background-color: rgb(150, 8, 96);
        border: 2px solid black;
        border-radius: 5px;
    }

    .send_message_button:hover::before {
        transform: scaleY(1);
    }

    .send_message_text{
        color: rgb(244, 187, 222);
        font-size: 18px;
        font-weight: 600;
        z-index: 5;
        position: relative;
    }

    .conatct_div{
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-top: 20px;
        cursor: pointer;
    }

    .contact_icon{
        width: 40px;
        height: 40px;
        margin-right: 20px;
    }

    .contact_text{
        font-size: 20px;
        color: rgb(244, 187, 222);
        text-align: left;
        position: relative;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        /* width: 80%; */
    }

    .contact_text::after{
        content: '';
        position: absolute;
        bottom: -5px;
        left: 0;
        width: 0;
        height: 2px;
        background-color: rgb(244, 187, 222);
        transition: width 0.3s ease;
    }

    .contact_text.a::after{
        background-color: #4B9CD3;
    }

    .contact_text:active::after, .contact_text:hover::after {
        width: 60%;
    }

    .cta-btn {
        background: #42b983;
        color: white;
        /* padding: 1rem 2rem; */
        border-radius: 5px;
        text-decoration: none;
    }

    @media (max-width: 1200px) {
        .contact {
            height: auto;
            width: 80%;
            margin-top: 100px;
            padding-top: 100px;
            padding-bottom: 100px;
        }
        
        .contact_section {
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-top: 5px
        }

        .contact_left, .contact_right {
            width: 100%;
            flex: none;
        }

        .contact_left_text, .contact_left_text_2 {
            text-align: center;
            width: 100%;
        }

        .contact_right {
            padding: 20px;
        }
        
    }

    @media (max-width: 768px) {
        .contact {
            height: 100%;
            width: 80%;
            margin-top: 100px;
            padding-top: 100px;
            padding-bottom: 100px;
        }

        .contact_title{
            font-size: 32px;
        }

        .contact_section{
            flex-direction: column;
            justify-content: flex-start;
            width: 100%;
            margin-top: 20px;
            gap: 50px;
        }

        .contact_left{
            width: 100%;
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: start;
        }

        .contact_left_text{
            font-size: 24px;
            width: 100%;
            text-align: center;
        }

        .contact_left_text_2{
            font-size: 18px;
            width: 100%;
            margin-top: 5px;
            text-align: center;
        }

        .contact_right{
            padding: 20px;
            border-radius: 10px;
        }

        .contact_right_input{
            margin-bottom: 20px;
            font-size: 16px;
        }

        .contact_right_textarea{
            margin-bottom: 30px;
            font-size: 16px;
        }

        .send_message_button{
            padding: 15px;
        }

        .send_message_text{
            font-size: 16px;
        }

        .conatct_div{
            margin-top: 20px;
            width: 80vw;
        }

        .contact_icon{
            width: 30px;
            height: 30px;
            margin-right: 10px;
        }

        .contact_text{
            font-size: 18px;
        }
    }
</style>
